(function() {
    'use strict';
    angular
        .module('emarket.main.post')
        .controller('PostSearchController', ['$stateParams', '$document', '$scope', '$anchorScroll', '$window', '$log', '$rootScope', '$timeout', '$state', '$mdMedia', '$location', '$mdSidenav', '$mdPanel', 'Post', 'PremiumPost', 'Category', 'Profile', 'Announcer', 'provinces', 'categories', 'currencies', 'ProvinceChooser', 'TRANSLATION', function($stateParams,
            $document,
            $scope,
            $anchorScroll,
            $window,
            $log,
            $rootScope,
            $timeout,
            $state,
            $mdMedia,
            $location,
            $mdSidenav,
            $mdPanel,
            Post,
            PremiumPost,
            Category,
            Profile,
            Announcer,
            provinces,
            categories,
            currencies,
            ProvinceChooser,
            TRANSLATION) {
            var vm = this;
            var currentCategory = null;
            var currentCondition = null;
            //use when is paginating
            var prevState;
            var scroll;
            var limit = 25;
            var resetPage = false;
            var selectedPost = {
                id: null,
                prev: null,
                next: null,
                element: null,
                open: false
            };

            vm.filteringProvince = {};
            vm.filteringCondition = {};
            vm.filteringCategory = {};
            vm.search = {};
            vm.isLoading = false;
            vm.categoryTree = [];
            vm.isMobile = $mdMedia('xs') || $mdMedia('sm');
            vm.adapter = false;
            vm.customFilter = {};
            vm.page = 1;
            vm.random = function() {
                return 0.5 - Math.random();
            };
            var announce = Announcer.create($scope);

            vm.sortBy = $location.search().orden;
            vm.changeOrder = function() {
                $location.search('orden', vm.sortBy);
                $location.search('omitir', null);
            };
            //defaults limitTo for filters
            vm.limit = {
                category: 3,
                province: 3
            };
            vm.toggleLimit = function(type) {
                vm.limit[type] = angular.isUndefined(vm.limit[type]) ? 3 : undefined;
            };
            var clearCategory = function() {
                Object.keys(vm.filteringCategory).forEach(function(key) {
                    vm.filteringCategory[key] = false;
                });
            };
            vm.categoryPremiumIndex = 0;

            vm.canShowBanner = function(index) {
                var canShow = false;
                if (vm.products.length < 6) {
                    if (index === vm.products.length - 1) {
                        canShow = true;
                    }
                } else {
                    canShow = index !== 0 && (index % 20 === 0 || index === 5);
                }
                if (canShow) {
                    vm.categoryPremiumIndex += 3;
                }
                return canShow;
            };
            var panel;

            var showFilter = function() {
                if (panel) {
                    panel.open();
                } else {
                    $mdPanel
                        .open({
                            position: $mdPanel
                                .newPanelPosition()
                                .absolute()
                                .top('0')
                                .left('0'),
                            templateUrl: 'main/post/search/filter/filter.panel.container.tpl.html',
                            animation: $mdPanel
                                .newPanelAnimation()
                                .duration(200)
                                .openFrom('.tabs-navigation-bottom')
                                .closeTo('.tabs-navigation-bottom')
                                .withAnimation($mdPanel.animation.SLIDE),
                            locals: {
                                model: vm
                            },
                            // disableParentScroll: true,
                            controller: 'FilterPanelController as model',
                            zIndex: 101,
                            trapFocus: true,
                            panelClass: 'filter_panel',
                            onOpenComplete: function() {
                                $rootScope.$emit('scroll:disable', true);
                            },
                            onCloseSuccess: function() {
                                $rootScope.$emit('scroll:disable');
                            }
                        })
                        .then(function(panelRef) {
                            panel = panelRef;
                        });
                }
            };
            announce.on(Post.events.SHOW_FILTER_DIALOG, function() {
                showFilter();
            });

            //fix autoscrolling top after open search detail

            var loadFilters = function() {
                var query = $location.search();
                var provinceChoose = ProvinceChooser.get();
                // disable until stable
                ProvinceChooser.onChange(function(province) {
                    vm.filteringProvince = {};
                    if (province) {
                        vm.filteringProvince[province.slug] = true;
                        vm.filterProvince(province, true);
                    } else {
                        vm.filterProvince({ slug: null });
                    }
                });
                if (query.provincia) {
                    var province = provinces.filter(function(province) {
                        return province.slug === query.provincia;
                    })[0];

                    if (province) {
                        vm.filteringProvince = {};
                        vm.filteringProvince[province.slug] = true;
                        vm.filterProvince(province, true);
                    } else {
                        $location.search('provincia', null);
                    }
                } else {
                    if (provinceChoose) {
                        // disable until stable
                        vm.filteringProvince = {};
                        vm.filteringProvince[provinceChoose.slug] = true;
                        vm.filterProvince(provinceChoose, true);
                    }
                }

                if (query.moneda) {
                    var currency = currencies.filter(function(currency) {
                        return currency.symbol === query.moneda;
                    })[0];
                    vm.filteringCurrency = {};
                    vm.filteringCurrency[query.moneda] = true;
                    vm.filterCurrency(currency, true);
                }
                if (query.condicion) {
                    var condition = null;
                    Object.keys(TRANSLATION).some(function(key) {
                        if (TRANSLATION[key] === query.condicion) {
                            condition = key;
                            return true;
                        }
                    });
                    if (condition) {
                        vm.filteringCondition = {};
                        vm.filteringCondition[condition] = true;
                        vm.filterCondition(condition, true);
                    }
                }
                var byPrice = false;
                var fromPrice, toPrice;
                if (query['desde-precio']) {
                    fromPrice = query['desde-precio'];
                    vm.fromPrice = parseInt(query['desde-precio']);
                    byPrice = true;
                }
                if (query['hasta-precio']) {
                    toPrice = query['hasta-precio'];
                    vm.toPrice = parseInt(query['hasta-precio']);
                    byPrice = true;
                }
                if (byPrice) {
                    vm.filterPrice(fromPrice, toPrice, true);
                }
                if (query.categoria) {
                    var category = categories.filter(function(category) {
                        return category.slug === query.categoria;
                    })[0];
                    var cas = categories.getTree(category);
                    vm.categoryTree = cas;
                    clearCategory();
                    vm.filteringCategory[category._id] = true;
                    vm.filterCategory(category, true);
                }
            };

            vm.acceptSuggesiton = function() {
                $location.search('q', vm.metadata.suggestion);
            };
            vm.clearPremium = function() {
                $location.search('premium', null);
            };
            var search = function(skip) {
                vm.products = [];
                vm.isLoading = true;
                announce.emit(Announcer.types.SEARCH_LOADING, true);
                $document[0].activeElement.blur();
                announce.emit(Post.events.SHOW_FILTER_BUTTON, false);
                vm.term = $location.search().q;

                vm.isPremium = $location.search().premium || $stateParams.isPremium;
                var term = Object.assign({}, $location.search());
                term.$limit = limit;
                term.$skip = skip || term.omitir || 0;
                if (skip === null) {
                    term.$skip = 0;
                    $location.search('omitir', null);
                    vm.page = 1;
                }
                delete term.omitir;
                delete term.producto;
                Object.keys(term).forEach(function(key) {
                    if (/^f_/.test(key)) {
                        if (!term.custom) {
                            term.custom = {};
                        }
                        term.custom[key.replace(/^f_/, '')] = term[key];
                        delete term[key];
                    }
                });
                vm.customFilter = term.custom;
                if (term.provincia) {
                    term.province = vm.province._id;
                    delete term.provincia;
                }
                if (term.categoria) {
                    term.category = currentCategory._id;
                    delete term.categoria;
                }
                if (term['desde-precio']) {
                    term.fromPrice = term['desde-precio'];
                    delete term['desde-precio'];
                }
                if (term['hasta-precio']) {
                    term.toPrice = term['hasta-precio'];
                    delete term['hasta-precio'];
                }
                if (term.condicion) {
                    term.condition = currentCondition;
                    delete term.condicion;
                }
                if (term.moneda) {
                    term.currency = vm.currency._id;
                    delete term.moneda;
                }
                if (term.usuario) {
                    term.username = term.usuario;

                    delete term.usuario;
                }
                if (vm.isPremium) {
                    term.isPremium = 1;
                    delete term.premium;
                }
                if ($stateParams.isPremium) {
                    term.ads = true;
                    vm.isAds = true;
                }
                return Post.$search(term)
                    .$asPromise()
                    .then(function(products) {
                        vm.metadata = products.$metadata;
                        vm.totalPage = Math.ceil(vm.metadata.total / limit);
                        vm.products = products;
                        vm.user = term.username ? products[0].owner : null;
                        if (vm.user) {
                            Profile.$find(vm.user._id)
                                .$asPromise()
                                .then(function(user) {
                                    vm.user = user;
                                });
                        }

                        if (term.category) {
                            vm.parentCategory = true;
                            Category.getAncestor(term.category).$then(function(response) {
                                vm.parentCategory = response;
                            });
                        } else {
                            vm.parentCategory = false;
                        }

                        var currenciesFilter = vm.products.$metadata.filter.currencies;
                        // var provincesFilter = vm.products.$metadata.filter.provinces;

                        var sortByTotal = function(a, b) {
                            return b.total - a.total;
                        };
                        var query = $location.search();
                        //sorting filters by total
                        vm.metadata.filter.categories = vm.metadata.filter.categories.sort(sortByTotal);

                        vm.metadata.filter.provinces = vm.metadata.filter.provinces.sort(function(a, b) {
                            if (query.provincia && a.province.slug === query.provincia) {
                                return -1;
                            }
                            if (query.provincia && b.province.slug === query.provincia) {
                                return 1;
                            }
                            return b.total - a.total;
                        });
                        // var filterCategory = vm.products.$metadata.filter.categories[0];

                        var currens = currencies.filter(function(currency) {
                            var pr = currenciesFilter.filter(function(pr) {
                                if (pr.currency === currency._id) {
                                    currency.count = pr.total;
                                    return true;
                                }
                            });
                            return pr.length > 0;
                        });
                        vm.currencies = currens;
                        vm.isLoading = false;
                        var premiumCategory;
                        if (term.category) {
                            premiumCategory = term.category;
                        } else {
                            premiumCategory = vm.metadata.filter.categories[0];
                        }
                        if (premiumCategory) {
                            var categoryId = premiumCategory.category ? premiumCategory.category._id : premiumCategory;

                            PremiumPost
                                .getFromCategory(categoryId)
                                .then(function (premiumPost) {
                                    vm.premiumPost = premiumPost.post;
                                });
                        }
                        vm.getPremiumPost = function() {
                            return vm.premiumPost;
                        };
                        announce.emit(Post.events.SHOW_FILTER_BUTTON);
                        announce.emit(Announcer.types.FILTER_PANEL_UPDATE, vm);
                        announce.emit(Announcer.types.SEARCH_LOADING, false);
                    })
                    .catch(function(err) {
                        vm.isLoading = false;
                        $log.error(err);
                    });
            };
            var initialPageLoad = function() {
                var skip = $location.search().omitir;
                if (skip && skip > 0) {
                    vm.page = skip / limit + 1;
                }
            };
            initialPageLoad();
            vm.changePage = function(page) {
                page = page || 1;
                vm.page = page;
                vm.totalPage = Math.ceil(vm.metadata.total / limit);

                var skip = (page - 1) * limit;
                $location.search('omitir', skip);
                vm.scrollToTop();
            };
            vm.showFilter = showFilter;
            //function for sorting the filters by total

            vm.clearTerm = function() {
                $location.search('q', null);
            };
            vm.removeProvinceFilter = function(province) {
                vm.province = null;
                vm.filteringProvince[province.slug] = null;
                //HACK wait for filterProvince to complete, this is really bad
                // FIXME:
                $timeout(function() {
                    $location.search('provincia', null);
                }, 100);
            };
            vm.filterProvince = function(province, ignoreReset) {
                if (vm.filteringProvince[province.slug]) {
                    resetPage = !ignoreReset;
                    vm.province = province;
                    $location.search('provincia', province.slug);
                    Object.keys(vm.filteringProvince).forEach(function(id) {
                        if (id !== province.slug) {
                            vm.filteringProvince[id] = false;
                        }
                    });
                } else {
                    vm.province = null;
                    $location.search('provincia', null);
                }
            };
            vm.clearUser = function() {
                $location.search('usuario', null);
                vm.user = null;
            };
            vm.jumpToCategory = function(category, index) {
                vm.categoryTree.splice(index + 1);
                currentCategory = category;
                clearCategory();
                $location.search('categoria', category.slug);
            };
            var isLastCategory = function() {
                var current = vm.categoryTree[vm.categoryTree.length - 1];
                if (current) {
                    return current.rgt - current.lft === 1 ? true : false;
                } else {
                    return false;
                }
            };
            vm.filterCategory = function(category, ignoreReset) {
                if (vm.filteringCategory[category._id]) {
                    resetPage = !ignoreReset;
                    if (isLastCategory()) {
                        vm.categoryTree[vm.categoryTree.length - 1] = category;
                    } else {
                        vm.categoryTree.push(category);
                    }
                    currentCategory = category;
                    $location.search('categoria', category.slug);
                    Object.keys(vm.filteringCategory).forEach(function(id) {
                        if (id !== category._id) {
                            vm.filteringCategory[id] = false;
                        }
                    });
                } else {
                    vm.filteringCategory[category._id] = false;
                    vm.categoryTree = [];
                    currentCategory = null;
                    $location.search('categoria', null);
                }
            };
            vm.filterCurrency = function(currency, ignoreReset) {
                vm.currency = currency;
                if (vm.filteringCurrency[currency.symbol]) {
                    resetPage = !ignoreReset;
                    $location.search('moneda', currency.symbol);
                    Object.keys(vm.filteringCurrency).forEach(function(symbol) {
                        if (symbol !== currency.symbol) {
                            vm.filteringCurrency[symbol] = false;
                        }
                    });
                } else {
                    $location.search('moneda', null);
                }
            };

            vm.filterPrice = function(fromPrice, toPrice, ignoreReset) {
                if (fromPrice) {
                    resetPage = !ignoreReset;
                    $location.search('desde-precio', fromPrice);
                } else {
                    $location.search('desde-precio', null);
                }
                if (toPrice) {
                    resetPage = !ignoreReset;
                    $location.search('hasta-precio', toPrice);
                } else {
                    $location.search('hasta-precio', null);
                }
            };
            vm.clearPrice = function() {
                $location.search('desde-precio', null);
                $location.search('hasta-precio', null);
                vm.fromPrice = null;
                vm.toPrice = null;
            };
            vm.filterCondition = function(condition, ignoreReset) {
                currentCondition = condition;
                if (vm.filteringCondition[condition]) {
                    resetPage = !ignoreReset;
                    $location.search('condicion', TRANSLATION[condition]);
                    Object.keys(vm.filteringCondition).forEach(function(key) {
                        if (key !== condition) {
                            vm.filteringCondition[key] = false;
                        }
                    });
                } else {
                    currentCondition = null;
                    $location.search('condicion', null);
                }
            };
            loadFilters();

            vm.clearFilters = function() {
                vm.clearUser();
                vm.clearPrice();
                currentCondition = null;
                currentCategory = null;
                vm.filteringProvince = {};
                vm.filteringCondition = {};
                vm.filteringCategory = {};
                vm.categoryTree = [];
                $location.search('categoria', null);
                $location.search('condicion', null);
                $location.search('provincia', null);
            };
            // HACK: save the current scroll position
            //

            if ($state.current.name === 'main.post.search.detail') {
                vm.search.showPost = true;
                $rootScope.$emit('scroll:disable', true);
            }
            var stateChangeEvent = $rootScope.$on('$stateChangeStart', function(event,
                toState,
                param,
                fromState) {
                vm.locationSearch = $location.search();
                if (fromState.name === 'main.post.search') {
                    scroll = $window.scrollY;
                }
                if (panel) {
                    panel.close();
                }
            });
            var ev = $rootScope.$on('$stateChangeSuccess', function(e, toState, toStateParam, fromState) {
                prevState = fromState;
                if (
                    toState.name === 'main.post.search.detail-desktop' ||
          toState.name === 'main.post.search.detail'
                ) {
                    $location.search(vm.locationSearch);
                    $rootScope.$emit('scroll:disable', true);
                    if (toState.name === 'main.post.search.detail') {
                        Post.showPostPanel(selectedPost.element, selectedPost);
                    }
                } else {
                    $rootScope.$emit('scroll:disable', false);
                    vm.search.showPost = false;
                    $timeout(function() {
                        $window.scrollTo(0, scroll);
                    });
                }
                if (fromState.name === 'main.post.search.detail') {
                    Post.hidePostPanel();
                    $timeout(function() {
                        announce.emit(Post.events.SHOW_FILTER_BUTTON);
                    }, 100);
                }

                $timeout(function() {
                    $rootScope.$emit('scroll:disable', false);
                }, 800);
            });

            vm.showPost = function(ev, post, index) {
                console.log('calling vm show post');
                if (vm.isMobile) {
                    ev.stopPropagation();
                    ev.preventDefault();

                    selectedPost.id = post;
                    selectedPost.index = index;
                    selectedPost.posts = vm.products;
                    selectedPost.element = ev.target;
                    $state.go('main.post.search.detail', { title: post });
                } else {
                    vm.search.showPost = true;
                }
            };
            vm.scrollToTop = function() {
                $window.scrollTo(0, 0);
            };
            var clearEvent = $scope.$watch(function() {
                return $location.search();
            },
            function() {
                //when the state is the detail and the prevState is the detail, ignore
                var ignoreChange =
            $state.current.name === 'main.post.search.detail' &&
            (prevState &&
              (prevState.name === 'main.post.search.detail-desktop' ||
                prevState.name === 'main.post.search.detail'));
                if (ignoreChange) {
                    prevState = null;
                    return;
                }
                if (resetPage) {
                    resetPage = false;
                    search(null);
                } else {
                    search();
                }
            },
            true);
            $scope.$on('$destroy', function() {
                clearEvent();
                stateChangeEvent();
                ev();
            });
        }]);
}());
